import { forwardRef, useRef, useState, useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';

//* HOCs
import withUIContext from 'context/consumerHOC/UIConsumer';
import withDataContext from 'context/consumerHOC/DataConsumer';
import withLanguageContext from 'context/consumerHOC/LanguageConsumer';

//* Components
import Text from 'components/common/Text';
import Button from 'components/common/Button';
import Container from 'components/common/Container';
import FormItem from 'components/common/Form/FormItem';
import FormInput from 'components/common/Form/FormInput';
import FormContainer from 'components/common/Form/FormContainer';
import { Input } from 'antd';

const GetInTouch = forwardRef(({ className, translate, contactUs, winWidth }, ref) => {
	//! Router
	const router = useRouter();

	//! State
	const [isSuccess, setIsSuccess] = useState(false);

	//! Ref
	const contactUsRef = useRef();

	useEffect(() => {
		if (contactUsRef?.current?.getFieldError('email').length > 0 || contactUsRef?.current?.isFieldTouched('email')) {
			contactUsRef?.current?.resetFields();
		}
	}, [contactUsRef, router.asPath]);

	//! On Finish
	const onFinish = useCallback((data) => {
		return contactUs(data).then(() => {
			setIsSuccess(true);

			contactUsRef?.current?.resetFields();

			setTimeout(() => {
				setIsSuccess(false);
			}, 2000);
		});
	}, []);

	return (
		<div
			ref={ref}
			className={`get-in-touch-wrap ${className || ''}`}
		>
			{!isSuccess ? (
				<FormContainer
					ref={contactUsRef}
					onFinish={onFinish}
				>
					<Container
						row
						full
					>
						<FormItem
							name={'first_name'}
							className={`if-item col-6 col-m-12`}
						>
							<FormInput placeholder={translate('firstNamePlaceholder')} />
						</FormItem>

						<FormItem
							name={'last_name'}
							className={`if-item col-6 col-m-12`}
						>
							<FormInput placeholder={translate('lastNamePlaceholder')} />
						</FormItem>

						<FormItem
							name={'subject'}
							required={false}
							className={`if-item col-6 col-m-12`}
						>
							<FormInput placeholder={translate('subjectPlaceholder')} />
						</FormItem>

						<FormItem
							name={'email'}
							validationType={'email'}
							className={`if-item col-6 col-m-12`}
						>
							<FormInput placeholder={translate('emailPlaceholder')} />
						</FormItem>
					</Container>

					<FormItem
						name={'message'}
						className={`if-item message-mt`}
					>
						<Input.TextArea
							autoSize={{ minRows: winWidth >= 768 ? 1 : 4 }}
							placeholder={translate('messagePlaceholder')}
						/>
					</FormItem>

					<div className={`form-btn-wrap`}>
						<Button
							btnType={'with-bg-color'}
							text={`submitRequest`}
							type={`submit`}
						/>
					</div>
				</FormContainer>
			) : (
				<div className={`success-message-wrapper align-center`}>
					<div className={`sm-line top`} />

					<Text
						tag={`h4`}
						className={`h4 minion3-medium primary-color9 uppercase m-title`}
						text={`thankYouWithSymbol`}
					/>

					<Text
						tag={`p`}
						className={`p p1 minion3-regular primary-color9 uppercase m-description`}
						text={`thankYouMessage`}
					/>

					<div className={`sm-line bottom`} />
				</div>
			)}
		</div>
	);
});

export default withLanguageContext(withUIContext(withDataContext(GetInTouch, ['contactUs']), ['winWidth']), ['translate']);
